import { Alert, Box, Container, Paper, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import NotificationPanel from "../components/NotificationPanel";
import useNotifications from "../hooks/useNotifications";

function Notifications() {
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.user?.user) || {};
  const {
    notifications,
    unreadNotificationCount,
    isLoadingNotifications,
    notificationsError,
    markNotificationAsRead,
  } = useNotifications(currentUser);

  return (
    <Box sx={{ bgcolor: "#f8fbff", minHeight: "100vh", py: { xs: 3, md: 5 } }}>
      <Container maxWidth="md">
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2.5, md: 4 },
            borderRadius: 4,
            border: "1px solid rgba(15, 23, 42, 0.08)",
            boxShadow: "0 18px 40px rgba(15, 23, 42, 0.06)",
          }}
        >
          {notificationsError ? (
            <Alert severity="error" sx={{ mb: 2 }}>
              {notificationsError}
            </Alert>
          ) : null}

          <NotificationPanel
            notifications={notifications}
            title="All notifications"
            subtitle={
              isLoadingNotifications
                ? "Loading notifications..."
                : `${unreadNotificationCount} unread updates from your alumni network.`
            }
            onItemClick={async (notification) => {
              await markNotificationAsRead(notification?.id);
              navigate(notification?.redirectUrl || "/notifications");
            }}
            emptyMessage={
              isLoadingNotifications
                ? "Loading notifications..."
                : "No notifications found."
            }
          />
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>
            Notifications are fetched from the API using the current user ID.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}

export default Notifications;
